import React, { useState, useEffect } from "react";
import Banner from "components/Banner";
import Footer from "components/Footer";
import FlowSkeleton from "components/FlowSkeleton";
import { MaxWidthWrapper } from "folksam-ui";
import { useApplicationConfiguration } from "hooks/ApplicationConfiguration";
import {
  extractNestedValue,
  extractFieldNameFromSubject,
  getTrackingScriptSrc
} from "services/utils.service";
import { generateHtmlEmail, extractAttachments } from "services/mail.service";
import { sendEmail } from "services/api.service";

import Flow from "containers/Flow";
import ErrorPage from "pages/ErrorPage";
import ReciptPage from "pages/ReceiptPage";
import Layout from "components/Layout";
import { removeHiddenGroupObjects } from "hooks/FlowMachine/utils";
import { useTracking } from "hooks/useTracking";
import useScript from "hooks/useScript";
import {
  executeTrackingQueue,
  trackPageBottom,
  generateTrackingDataLayer
} from "services/tracking.service";
import { ErrorBoundary } from "components/ErrorBound/ErrorBound";
function App({ applicationSettings }) {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmittedError, setIsSubmittedError] = useState(false);
  const {
    heading,
    intro,
    endpoint,
    metadata,
    receivers: recipients,
    emailSubject,
    customerEmail,
    answerEmailField,
    trackingClaimProduct,
    trackingClaimEvent,
    trackingPageName,
    flow,
    isLoading,
    isErroneous
  } = useApplicationConfiguration({
    url: applicationSettings.apiUrl
  });

  const { loaded: trackingLoaded } = useScript(getTrackingScriptSrc(), {
    defer: true
  });

  const datalayer = generateTrackingDataLayer({
    claim_product: trackingClaimProduct,
    claim_process: trackingClaimEvent
  });
  const { track } = useTracking(datalayer);
  useEffect(() => {
    if (
      trackingClaimProduct !== "" &&
      trackingClaimEvent !== "" &&
      trackingPageName !== ""
    ) {
      track("claim_start");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trackingClaimEvent, trackingClaimProduct, trackingPageName]);

  // once tracking script has loaded, empty the queue and track pageBottom event
  useEffect(() => {
    if (trackingLoaded) {
      trackPageBottom();
      executeTrackingQueue();
    }
  }, [trackingLoaded]);

  async function handleSubmit(data) {
    const subjectValueField = extractFieldNameFromSubject(emailSubject);
    /**
     *  we need to first check the field "answerEmailField" and set that as the from email, if that does not exist, we check the "customerEmail" field, last fallback is the regular email adress
     */
    const from = extractNestedValue(data, answerEmailField)[0]
      ? extractNestedValue(data, answerEmailField)[0]
      : extractNestedValue(data, customerEmail)[0] || "webformular@3kronor.se";
    const name = extractNestedValue(data, subjectValueField);
    const subject = emailSubject.replace(/\{\{(.*)\}\}/, name[0]);
    const attachments = extractAttachments(data);
    // const attachments = [];
    const html = generateHtmlEmail(
      data.map(step => removeHiddenGroupObjects(step))
    );
    // TODO: this  is not functional, rethink when possible
    // if (appSettings.sendReplyEmail) {
    //   recipients.push(replytoEmail);
    // }
    try {
      await sendEmail({
        attachments,
        html,
        subject,
        recipients,
        from,
        endpoint,
        metadata,
      });
      setIsSubmitted(true);
    } catch (error) {
      setIsSubmittedError(true);
    }
  }

  return (
    <Layout>
      <Banner title={heading} intro={intro} isSubmitted={isSubmitted} />
      <ErrorBoundary>
        {isLoading ? (
          <MaxWidthWrapper>
            <FlowSkeleton steps={4}></FlowSkeleton>
          </MaxWidthWrapper>
        ) : isErroneous || isSubmittedError ? (
          <ErrorPage></ErrorPage>
        ) : isSubmitted ? (
          <ReciptPage></ReciptPage>
        ) : (
          <MaxWidthWrapper>
            <Flow flow={flow} onSubmit={handleSubmit} />
          </MaxWidthWrapper>
        )}
      </ErrorBoundary>
      <Footer />
    </Layout>
  );
}

export default App;
